module.exports = __webpack_public_path__ + "files/74b6a8ce2c0ddfc1a367f0d46be062b7.png";